import { render, staticRenderFns } from "./StyleBulkOverview.vue?vue&type=template&id=48e490d7&scoped=true&"
import script from "./StyleBulkOverview.vue?vue&type=script&lang=js&"
export * from "./StyleBulkOverview.vue?vue&type=script&lang=js&"
import style0 from "./StyleBulkOverview.vue?vue&type=style&index=0&id=48e490d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e490d7",
  null
  
)

export default component.exports